import { getAccess } from "../../helpers/ReduxHelpers";

/**
 * EMS settings (Categories, Auto Tagging & Email Config, Report Schedules) need the ESCALATION_ADMIN
 * module, as the backend checks. ROLE_PROSHIPADMIN alone only gives ticket access.
 */
export const isEscalationAdmin = () => getAccess().includes("ESCALATION_ADMIN");
